// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1eJuq","notes":"Notes_notes__2pfCq"};